import {
  LayoutDashboard, Map, Bell, Users, Truck, ShieldCheck,
  Star, FileBarChart2, Calendar as CalendarIcon, Route, ClipboardList, Receipt
} from 'lucide-react';
import type { UserRole } from '../../types/user';
import { NAV_ROUTES } from '../../utils/constants';

export interface NavItem {
  label: string;
  icon: React.ReactNode;
  to: string;
  roles: UserRole[];
}

// Fuente única para Sidebar (desktop) y MobileNav (bottom nav): antes vivía
// solo en Sidebar.tsx y MobileNav habría necesitado su propia copia.
export const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard',      icon: <LayoutDashboard size={20} />, to: NAV_ROUTES.DASHBOARD,  roles: ['executive', 'admin'] },
  { label: 'Monitoreo',      icon: <Map size={20} />,             to: NAV_ROUTES.MONITORING, roles: ['supervisor', 'admin'] },
  { label: 'Alertas',        icon: <Bell size={20} />,            to: NAV_ROUTES.ALERTS,     roles: ['supervisor', 'admin'] },
  { label: 'Conductores',    icon: <Users size={20} />,           to: NAV_ROUTES.DRIVERS,    roles: ['supervisor', 'executive', 'admin'] },
  { label: 'Vehículos',      icon: <Truck size={20} />,           to: NAV_ROUTES.VEHICLES,   roles: ['supervisor', 'executive', 'admin'] },
  { label: 'Viajes',         icon: <Route size={20} />,           to: NAV_ROUTES.TRIPS,      roles: ['supervisor', 'executive', 'admin'] },
  // Las novedades las LEEN los cuatro roles: `GET /logbook-entries` responde 200
  // al Ejecutivo (consolidado) y al Operador (solo las suyas). Quién puede
  // REGISTRAR o CORREGIR es otra cosa y lo decide `utils/logbook.ts`.
  { label: 'Novedades',      icon: <ClipboardList size={20} />,   to: NAV_ROUTES.LOGBOOK,    roles: ['operator', 'supervisor', 'executive', 'admin'] },
  // Los gastos los LEEN los cuatro roles, igual que las novedades: `GET
  // /expenses` responde 200 al Ejecutivo (consolidado) y al Operador (solo los
  // suyos). Quién puede REGISTRAR o CORREGIR lo decide `utils/expenses.ts`.
  //
  // Es también la superficie desde la que el Operador registra desde el móvil:
  // no hay FAB nuevo a propósito — «Mi Desempeño» ya tiene el SOS de pánico
  // (FE-17) y el de novedad (FE-13), y un tercer botón flotante repetiría el
  // choque que resolvió el issue #72.
  { label: 'Gastos',         icon: <Receipt size={20} />,         to: NAV_ROUTES.EXPENSES,   roles: ['operator', 'supervisor', 'executive', 'admin'] },
  { label: 'Calendario',     icon: <CalendarIcon size={20} />,    to: NAV_ROUTES.CALENDAR,   roles: ['operator', 'supervisor', 'executive', 'admin'] },
  { label: 'Reportes',       icon: <FileBarChart2 size={20} />,   to: NAV_ROUTES.REPORTS,    roles: ['supervisor', 'executive', 'admin'] },
  { label: 'Mi Desempeño',   icon: <Star size={20} />,            to: NAV_ROUTES.OPERATOR,   roles: ['operator'] },
  // 'supervisor' ve una versión acotada de esta misma pantalla: solo la
  // pestaña Usuarios, y solo para dar de alta/editar Operadores de su propia
  // sub-unidad (issue #77 — PRODUCT.md §4.8 "crear/eliminar Operador: Sí, su
  // sub-unidad"). AdminPage.tsx decide qué pestañas mostrar según el rol.
  { label: 'Administración', icon: <ShieldCheck size={20} />,     to: NAV_ROUTES.ADMIN,      roles: ['admin', 'supervisor'] },
];
